
export function hasRequiredFields<TObj extends Record<string, any>, RequiredKeys extends string[]>(obj: TObj, requiredKeys: RequiredKeys)
{
    const keys = [...Object.keys(obj)].filter((key) =>
    {
        const _key = key as keyof keyof TObj;
        return (obj[_key] !== null) || (obj[_key] !== undefined);
    });

    return requiredKeys.every((key) => keys.find((_key) => key === _key) !== undefined);
};




export const convertIntervalToInt = (interval: string | undefined) =>
{
    if (!interval) return 0;
    const replaceMany = (list: string[], val: string) =>
    {
        let string = val;
        list.forEach(item => string = string.replace(item, ""));
        return string;
    };

    let month = 0;

    const monthMatch = interval.match(/[P|Y]\d*M/);
    const yearMatch = interval.match(/P\d*Y/);

    if (yearMatch?.length) {
        const int = Number(replaceMany(["P", "Y"], yearMatch[0]));
        month += (int * 12);
    }

    if (monthMatch?.length) {
        const int = Number(replaceMany(["P", "Y", "M"], monthMatch[0]));
        month += int;
    }

    return month;
};

export const getExpireDate = (month: number) =>
{
    const expireDate = new Date();
    expireDate.setDate(1);

    //const duration = expireDate.getMonth() + month;
    //expireDate.setMonth(duration);

    //TESTING:
    const duration = expireDate.getDate() + month;
    expireDate.setDate(duration);

    return expireDate.toISOString();
};


export const breakpoint = .8;

export const getContentMaxHeight = (breakpoint: number) =>
{
    return `${(breakpoint * 100) - 6}vh`;
};